export default "__VITE_ASSET__BxvVw8n2__"